import AppLayout from "@/layouts/AppLayout";
import PageHeading from "@/components/PageHeading";
import usePageTitle from "@/hooks/usePageTitle";
import useDashboardGreeting from "@/hooks/useDashboardGreeting";
import useEffectiveDisplayUser from "@/hooks/useEffectiveDisplayUser";
import DashboardSubtitle from "./_components/DashboardSubtitle";
import HomeDashboardTabs from "./_HomeDashboardTabs";

export default function HomeDashboardLayout() {
  const user = useEffectiveDisplayUser();
  const greeting = useDashboardGreeting();
  const firstName = user.given_name || "there";
  const headingTitleText = `${greeting.phrase}, ${firstName}.`;
  const headingTitle = (
    <>
      {greeting.phrase}, <span className="text-sys-brand-primary">{firstName}.</span>
    </>
  );
  usePageTitle("/home/*", headingTitleText);

  return (
    <AppLayout interior>
      <PageHeading
        eyebrow={greeting.dateLabel}
        title={headingTitle}
        containerClassName="pt-6 lg:pt-8"
        titleClassName="text-sys-brand-on-surface text-headline-medium-bold font-serif lg:text-headline-large-bold"
      />
      <DashboardSubtitle />
      <HomeDashboardTabs />
    </AppLayout>
  );
}
